import * as i18nIsoCountries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

// import this file in places where you use the i18n-iso-countries lib to set up locales

// need to register language to minimize the file size
i18nIsoCountries.registerLocale(enLocale)
